<details #select class="select" (click)="toggleDropdown()" (focusout)="onFocusOut()">
    <summary class="select-styled">{{ value }}</summary>
</details>
<ng-container *ngIf="showDropdown">
    <ul class="select-options">
        <li *ngFor="let option of options"
            [ngClass]="{'active' : option === value }"
            (click)="onChange(option)">
            <span>{{ option }}</span>
        </li>
    </ul>
</ng-container>